import { Building2, Factory, TrendingUp, Landmark } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { SEGMENTOS } from "../data/content";

const ICONS = [Building2, Factory, TrendingUp, Landmark];

export const Segmentos = () => (
  <section
    id="proyectos"
    data-testid="proyectos-section"
    className="relative bg-coal py-20 text-white sm:py-28 lg:py-36"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead
        num="04"
        eyebrow="Alcance"
        title="Nuestros proyectos y clientes potenciales"
        dark
        testId="proyectos-head"
      />

      <Reveal delay={0.15}>
        <div className="relative mt-16 overflow-hidden">
          <img
            src="/img/proyectos.webp"
            alt="Trabajador de OESCA con casco en sitio de obra"
            data-testid="proyectos-banner-image"
            className="h-56 w-full object-cover sm:h-72"
          />
          <div className="absolute inset-0 bg-coal/45" />
          <p className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-white/80">
            Ingeniería de alta resistencia — ejecución Oesca
          </p>
        </div>
      </Reveal>

      <div className="mt-5 grid gap-px bg-white/10 sm:grid-cols-2">
        {SEGMENTOS.map((s, i) => {
          const Icon = ICONS[i];
          return (
          <Reveal key={s.title} delay={0.08 * i}>
            <article
              data-testid={`segmento-card-${i + 1}`}
              className="group relative h-full bg-coal p-8 transition-colors duration-500 hover:bg-cafe-deep sm:p-10"
            >
              <span className="absolute left-0 top-0 h-0.5 w-0 bg-cafe transition-[width] duration-700 group-hover:w-full" />
              <div className="flex h-12 w-12 items-center justify-center border border-white/15 bg-white/5 transition-colors duration-500 group-hover:border-cafe group-hover:bg-cafe">
                <Icon className="h-5 w-5 text-cafe transition-colors duration-500 group-hover:text-white" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-semibold leading-snug text-white sm:text-3xl">
                {s.title}
              </h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-white/65">{s.text}</p>
            </article>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
